import React, { Component } from 'react'
import Contact from './contact'
import './home.min.css'
import { HashLink } from 'react-router-hash-link'

class index extends Component {
  render() {

    return (
      <div>
        <section id="home-parallax" className="parallax" data-stellar-background-ratio="0.5">
            <div className="container text-center">
                <h1 className="typed-text">拓展市場的最佳夥伴
                    <span className="element" data-elements="Clean, Modern, Multipurpose, Creative"></span>
                </h1>
                <p className="lead">提供一站式專業電子商務及實體通路解決方案予零售商，製造商和品牌商。</p>
                <span className="parallax-buttons">                      
                    <HashLink smooth to="/#contact" className="btn border-white btn-lg">
                        Contact us
                    </HashLink>
                </span>
            </div>
        </section>
        <div className="divide60" id="aboutus"></div>
        <div className="container">
            <div className="row">
                <div className="col-sm-8 col-sm-offset-2">
                    <div className="center-heading">
                        <h2 className="wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="100ms">About US</h2>
                        <span className="center-line"></span>
                        <p className="sub-text wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="300ms">
                            橙風科技有限公司 (Oranwind Co., Ltd) 主要提供商品代理內/外銷，致力於推廣新商品在台灣或是跨境電商上的銷售，讓更多消費者能在數位化的科技下體驗更多生活上的美好經驗！
經過多年的努力與通路深耕， Oranwind 已經成功的建立許多的科技精品在台灣的銷售基礎，代理產品跨足 數位周邊商品 / 車用音響 / 教育商品 / 生活用品 等四大類商品。
                        </p>
                    </div>
                </div>
            </div>
            <div className="divide70"></div>
            <div className="row">
                <div className="col-md-6 col-sm-12 margin30">
                    <div className="service-box-4 wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="100ms">
                        <div className="service-ico">
                            <i className="pe-7s-diamond"></i>
                        </div>
                        <div className="service-text">
                            <h4>品牌運營/代理</h4>
                            <p>
                                讓我們協助您並結合從線上帶動流量至線下商店，提供您的顧客一致的品牌體驗，以及更好的購物體驗。
                            </p>
                            {/* <p><a href="#">More info <i className="fa fa-angle-right"></i></a></p> */}
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 margin30">
                    <div className="service-box-4 wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="200ms">
                        <div className="service-ico">
                            <i className="pe-7s-photo"></i>
                        </div>
                        <div className="service-text">
                            <h4>品牌官網建置</h4>
                            <p>
                                我們協助客戶建置品牌官網、購物車及保固系統服務，為客戶提供完善的商品及服務資訊。
                            </p>
                            {/* <p><a href="#">More info <i className="fa fa-angle-right"></i></a></p> */}
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 margin30">
                    <div className="service-box-4 wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="200ms">
                        <div className="service-ico">
                            <i className="pe-7s-display2"></i>
                        </div>
                        <div className="service-text">
                            <h4>網絡營銷</h4>
                            <p>
                                為客戶管理網絡營銷以增加流量，如 Google 關鍵字廣告、搜索引擎優化、社群媒體付費廣告、電子郵件行銷、影片行銷以及更多。
                            </p>
                            {/* <p><a href="#">More info <i className="fa fa-angle-right"></i></a></p> */}
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 margin30">
                    <div className="service-box-4 wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="200ms">
                        <div className="service-ico">
                            <i className="pe-7s-paper-plane"></i>
                        </div>
                        <div className="service-text">
                            <h4>電商代營運</h4>
                            <p>
                                提供最實際的全球網路電子商務銷售實戰技巧，幫助了中小企業廠商迅速進入國際電子商務市場
                            </p>
                            {/* <p><a href="#">More info <i className="fa fa-angle-right"></i></a></p> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="divide70" id="product"></div>
            <div className="row">
                <div className="col-sm-8 col-sm-offset-2">
                    <div className="center-heading">
                        <h2 className="wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="100ms">代理/經銷品牌</h2>
                        <span className="center-line"></span>
                        <p className="sub-text wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="300ms">
下列為 Oranwind 代理 / 經銷的品牌，我們致力於將品牌價值及形象建立完善，過程中會針對品牌建立形象官網及網路行銷，結合線上 / 線下通路，提升商品的曝光度，將品牌的價值完整呈現。
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 margin20">
                    <h3 className="heading">Anker</h3>
                    <p>
美國雅馬遜上銷售第一的電子周邊商品，致力於打造新穎、更貼近現代人生活的智慧3C，商品包含：充電線材、行動電源、藍牙音箱等。
                    </p>
                    <img src="media/anker-logo-H70px.png" className="img-responsive" alt=""></img>
                </div>
                <div className="col-md-4 margin20">
                    <h3 className="heading">SoundStream</h3>
                    <p>
美國知名汽車音響品牌，有著多年的超低音藝術，為車用改裝音響的藝品，商品包含：車用汽車音響、擴大機、車用喇叭等。
                    </p>
                    <img src="media/soundstream-logo_0.png" className="img-responsive" alt=""></img>
                </div>
                <div className="col-md-4 margin20">
                    <h3 className="heading">MediaTek</h3>
                    <p>
                        台灣知名無線通訊、物聯網提供系統級晶片解決方案的半導體公司，橙風主要經銷物聯網解決方案及開發版。
                    </p>
                    <img src="media/mediatek.jpg" className="img-responsive" alt=""></img>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 margin20">
                    <h3 className="heading">Micro:bit</h3>
                    <p>
Micro Bit 是基於 ARM 結構的嵌入式系統，由 BBC 設計用於國中、小學學生學習程式邏輯和語言的掌控，將對未來職涯有舉足輕重的影響。
                    </p>
                    <img src="media/Microbit.png" className="img-responsive" alt=""></img>
                </div>
                <div className="col-md-4 margin20">
                    <h3 className="heading">Njuturn</h3>
                    <p>
                        優質咖啡及輕食專賣店，提供多種甜點製作、單品咖啡豆及輕食外送服務。
                    </p>
                    <img src="media/njuturn.jpg" className="img-responsive" alt=""></img>
                </div>                
            </div>
            <div className="divide70" id="contact"></div>
            <div className="row">
                <div className="col-sm-8 col-sm-offset-2">
                    <div className="center-heading">
                        <h2 className="wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="100ms">連絡我們</h2>
                        <span className="center-line"></span>
                        <p className="sub-text wow animated fadeIn" data-wow-duration="700ms" data-wow-delay="300ms">
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <Contact>
                </Contact>
            </div>
        </div>
      </div>
    )
  }
}

export default index



// WEBPACK FOOTER //
// ./src/home/home.js